import axios from "@/modules/shared/AxiosInterceptor"
import { AxiosResponse } from "axios"
import { IOrganizationProvider, OrgProviderCredentials } from "@/types/organization-providers"
import { ProvidersType } from "@/types/providers.types"

export function getOrganizationProviders(): Promise<AxiosResponse<IOrganizationProvider[]>> {
  const baseUrl = "/organization-providers/all"
  return axios
    .get(baseUrl)
    .then((response) => response)
    .catch((error) => {
      throw error
    })
}

interface PutOrgProviderCredentialPayload {
  credentials: OrgProviderCredentials
  provider: ProvidersType
  id?: string
}

export function putOrganizationProvidersCredentials({
  credentials,
  provider,
  id,
}: PutOrgProviderCredentialPayload): Promise<AxiosResponse<IOrganizationProvider>> {
  const baseUrl = "/organization-providers/credentials"
  return axios
    .put(baseUrl, {
      id,
      provider,
      credentials,
    })
    .then((response) => response)
    .catch((error) => {
      throw error
    })
}

export function deleteOrgProviderCredentials(id: string): Promise<AxiosResponse<IOrganizationProvider[]>> {
  const baseUrl = "/organization-providers"
  return axios
    .delete(`${baseUrl}/${id}`)
    .then((response) => response)
    .catch((error) => {
      throw error
    })
}

export function getProvidersConfig(): Promise<AxiosResponse<IOrganizationProvider[]>> {
  const baseUrl = "/organization-providers/config"
  return axios
    .get(baseUrl)
    .then((response) => response)
    .catch((error) => {
      throw error
    })
}
